import { Button, CircularProgress } from '@mui/material'

import { RefreshKycMutation } from './useKyc'

export const RefreshButton = ({
  kycId,
  refresh,
}: {
  kycId: string
  refresh: RefreshKycMutation
}) => {
  const isRefreshing = refresh.isPending && refresh.variables === kycId

  return (
    <Button
      variant="contained"
      size="large"
      onClick={() => !refresh.isPending && refresh.mutate(kycId)}
      disabled={refresh.isPending}
      sx={{
        textTransform: 'none',
        borderRadius: '8px',
        fontSize: '13px',
        px: 1.5,
        height: '30px',
        whiteSpace: 'nowrap',
        width: '100px',
      }}
    >
      {isRefreshing ? <CircularProgress size={16} color="inherit" /> : 'Refresh KYC'}
    </Button>
  )
}
